import { compose } from 'recompose';
import { withFormik } from 'formik';

import { withCaptchaTokenState } from './withCaptchaTokenState';
import { withCaptchaTokenHandlers } from './withCaptchaTokenHandlers';

export const withCaptchaEnhancedFormik = (formikConfig) =>
  compose(
    withCaptchaTokenState,
    withFormik(formikConfig),
    withCaptchaTokenHandlers
  );
